import * as Blockly from 'blockly/core';
import { VmtFieldFlyoutText } from '../fields/VmtFlyout/VmtFlyoutEditField';
// import { createMinusField } from '../fields/field_minus';
// import { createPlusField } from '../fields/field_plus';
// import { getExtraBlockState } from '../fields/serialization_helper';
// import './vmt_parameter';
// import './vmt_param_drop';
import { Colors } from '../../const';

const REUSABLE_BRICK_COLOR = Colors.REUSABLE_BRICK_COLOR; //'#138D90';


// 30x30px white image of '(' sign, white color
// const paramOpenImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsAAAA7AAWrWiQkAAAGHaVRYdFhNTDpjb20uYWRvYmUueG1wAAAAAAA8P3hwYWNrZXQgYmVnaW49J++7vycgaWQ9J1c1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCc/Pg0KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyI+PHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj48cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0idXVpZDpmYWY1YmRkNS1iYTNkLTExZGEtYWQzMS1kMzNkNzUxODJmMWIiIHhtbG5zOnRpZmY9Imh0dHA6Ly9ucy5hZG9iZS5jb20vdGlmZi8xLjAvIj48dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPjwvcmRmOkRlc2NyaXB0aW9uPjwvcmRmOlJERj48L3g6eG1wbWV0YT4NCjw/eHBhY2tldCBlbmQ9J3cnPz4slJgLAAAA40lEQVRIS+2WzQmDQBBG19zSQ8BKhHSRLizCFizBCnIMeLeHpAWvXt/m4A/LhxCUnRUh77TMDDx2XHfHuT9nAWiATuOmAJ2fAFrNmwDUgXQAHloTHaCcpZO40proADkwBNKn1pgAtIH0rXkTgGLp7ygutcYEoIm124sGfnAP1q9gbQeQS5sLrTFBfyHNb2Vrq51zznnvPxrbyi5xDPaKrxrYyi5xlmU3jZmxcqrtH4UZoA/EjebNkHu617wZK3d1rTVmyNSRdNf6HqcZedwor5Z+H9Dy5aAdIQ+/d/IRt00uPSVfgRhK5e4wQzIAAAAASUVORK5CYII=';

// 10x30px white image of '(' sign, white color
// const paramOpenWhiteImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAeCAYAAAAVdY8wAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsAAAA7AAWrWiQkAAAGHaVRYdFhNTDpjb20uYWRvYmUueG1wAAAAAAA8P3hwYWNrZXQgYmVnaW49J++7vycgaWQ9J1c1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCc/Pg0KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyI+PHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj48cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0idXVpZDpmYWY1YmRkNS1iYTNkLTExZGEtYWQzMS1kMzNkNzUxODJmMWIiIHhtbG5zOnRpZmY9Imh0dHA6Ly9ucy5hZG9iZS5jb20vdGlmZi8xLjAvIj48dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPjwvcmRmOkRlc2NyaXB0aW9uPjwvcmRmOlJERj48L3g6eG1wbWV0YT4NCjw/eHBhY2tldCBlbmQ9J3cnPz4slJgLAAAAzElEQVQ4T72TvQ3CQAyFX+jYASmTRGILtsgQWSEjZAJKpPTZAVZIm/YdxSXGPEySBr7Ksj+d78cH/BWSHclB82+QHNIMyV7rQJZaJ00kL+qAZL1Is9ioA5IlyclJV3WALPZOumsdyFJl/bJYqwPMV7G22sHFZxffXPyCZCltK3WA4Eq0DmkNAEgpPTSHSPxGJB41gUgsiuKkOSM49ecQLJAcndhp3ZB3HrVuBG/dqmPIVK+uqvMYfwFkubH+O7ZgB9sj+/1uftl+U/o9T5OySuWDwN4aAAAAAElFTkSuQmCC';

// 10x30px white image of '(' sign, white color
const paramOpenYellowImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAeCAYAAAAVdY8wAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsAAAA7AAWrWiQkAAAGHaVRYdFhNTDpjb20uYWRvYmUueG1wAAAAAAA8P3hwYWNrZXQgYmVnaW49J++7vycgaWQ9J1c1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCc/Pg0KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyI+PHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj48cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0idXVpZDpmYWY1YmRkNS1iYTNkLTExZGEtYWQzMS1kMzNkNzUxODJmMWIiIHhtbG5zOnRpZmY9Imh0dHA6Ly9ucy5hZG9iZS5jb20vdGlmZi8xLjAvIj48dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPjwvcmRmOkRlc2NyaXB0aW9uPjwvcmRmOlJERj48L3g6eG1wbWV0YT4NCjw/eHBhY2tldCBlbmQ9J3cnPz4slJgLAAAA+ElEQVQ4T72TMXLCMBBFnz2UpKDkEDTcgDQMJ2CGK3ADbsAF0vsAlKkZilDmDKFKaVtQMrspAGW1NnEa+NXq7xt9jbSCp0pq1lKz8X4iqdloQDWgEih8HwAJrAxUSsXUM0jF4gZpQOXI0jPIiaEEygjVvHkGLpGFifzwfQCkZJxEViw8A9er+Gu33NQzU7+b+ldyYpjElow9c9nxzCQxB3zaNS4aAIW992gD76kJKi/eog3MMkbeI4I9ttZsG4IcIO/zrXCIbsarhXDRu1hlzI2fqvHWgZVnotxUf/l+VGMe730BADmy/P8RzAB3w/a8nV82UHRCj9cPECXHpL0X13wAAAAASUVORK5CYII=';

// 30x30px white image of ')' sign, white color
// const paramCloseImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsAAAA7AAWrWiQkAAAGHaVRYdFhNTDpjb20uYWRvYmUueG1wAAAAAAA8P3hwYWNrZXQgYmVnaW49J++7vycgaWQ9J1c1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCc/Pg0KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyI+PHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj48cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0idXVpZDpmYWY1YmRkNS1iYTNkLTExZGEtYWQzMS1kMzNkNzUxODJmMWIiIHhtbG5zOnRpZmY9Imh0dHA6Ly9ucy5hZG9iZS5jb20vdGlmZi8xLjAvIj48dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPjwvcmRmOkRlc2NyaXB0aW9uPjwvcmRmOlJERj48L3g6eG1wbWV0YT4NCjw/eHBhY2tldCBlbmQ9J3cnPz4slJgLAAAA+UlEQVRIS+2WsQ3CMBBFbRahYgcaJLZgA8oMwQoZgQlSIST6NGxACQ1SWkT3TBNLx8kSjuFc8arL3Ulf/+zYdu5PAqAHOp03BejDCNDreikznUhwjoH3flnVOdBG16Pzne4xAzgJ4Qcw1z0mAHNgEOI/W++PJEa+0j1mKNd7Xc8lZ1drDiJei9gWYCPHreumSGGg0fUcSkbtQgg3nZtKkbBz7qkTUykV/poiYe/9QnzeRWwHsJKbS9dzKXG8jUEI4fJeyqdEWB4aRxHbATTi/616Q12FcJ0HAdAJ0aGK28R1WHRMTiIh2uoeE9Qrs866RsZ3dR2nf37NCx+uIWyGPd1nAAAAAElFTkSuQmCC';

// 10x30px white image of ')' sign, white color
// const paramCloseWhiteImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAeCAYAAAAVdY8wAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsAAAA7AAWrWiQkAAAGHaVRYdFhNTDpjb20uYWRvYmUueG1wAAAAAAA8P3hwYWNrZXQgYmVnaW49J++7vycgaWQ9J1c1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCc/Pg0KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyI+PHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj48cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0idXVpZDpmYWY1YmRkNS1iYTNkLTExZGEtYWQzMS1kMzNkNzUxODJmMWIiIHhtbG5zOnRpZmY9Imh0dHA6Ly9ucy5hZG9iZS5jb20vdGlmZi8xLjAvIj48dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPjwvcmRmOkRlc2NyaXB0aW9uPjwvcmRmOlJERj48L3g6eG1wbWV0YT4NCjw/eHBhY2tldCBlbmQ9J3cnPz4slJgLAAAA2klEQVQ4T8WTvQ3CMBBGP7MIFTvQILEFG1BmCFZgBCagQkj0adiAEhokWkT3TEEcLpdLOsSrzuenzz+ypZ8A1MDe9zsAdW4Aaj9fmEg6l0FKaT6aDGxLapO88U4LcDLiE5h6R/qIU+Bh5MH9RltYeKfFpe5Kf9LVJEkHUy9N3QVY2eX9fAcrApUGllbO+eZ7oSjp5RtDYo9QTCnNzPBu6i/Awh6m9KPEdSlyzpdSR6K95KOpvwCVub/RF3Q1YvyAgb2RHmFa8Lwq70TS1jtS/xfG+yo0/zpO+j9vaFohbE2OHjMAAAAASUVORK5CYII=';

// 10x30px white image of ')' sign, white color
const paramCloseYellowImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAeCAYAAAAVdY8wAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsAAAA7AAWrWiQkAAAGHaVRYdFhNTDpjb20uYWRvYmUueG1wAAAAAAA8P3hwYWNrZXQgYmVnaW49J++7vycgaWQ9J1c1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCc/Pg0KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyI+PHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj48cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0idXVpZDpmYWY1YmRkNS1iYTNkLTExZGEtYWQzMS1kMzNkNzUxODJmMWIiIHhtbG5zOnRpZmY9Imh0dHA6Ly9ucy5hZG9iZS5jb20vdGlmZi8xLjAvIj48dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPjwvcmRmOkRlc2NyaXB0aW9uPjwvcmRmOlJERj48L3g6eG1wbWV0YT4NCjw/eHBhY2tldCBlbmQ9J3cnPz4slJgLAAAA8ElEQVQ4T8WTsXHDMAxFH7WFh3DjMhukTeM7r5ANvEEWcO8yhcq0KdOlSRbwAjmZtGsgTSBRIOxz48urgM9//0ARgrsgmV4yO6/PkEyvBdWCSqb350ZH4tOalHi6miyFraVqQeXEs/eMSGE/GguDnFl4DwByZiGFwy3ztiMMrLxnxKW+mN7NbYDyWnWPVkTGdytTYjk/dMzmPLIhTARU+fZaaCRx8lJsDAiNCR6q9qeqJ2RgVV/G9DaxY22lwsckt4wfGXir6gk5srltgzJf1TvHCyyZXZV2CNOa9fp7tuumwtZ7oP0L47kMyfQXk/6fX9DOx055W0vhAAAAAElFTkSuQmCC';

/** Drag strategy that duplicates the block on drag. */
class DragToDupe {
    constructor(block) {
        this.block = block;
    }

    isMovable() {
        return true;
    }

    startDrag(e) {
        // const prevGroupId = Blockly.Events.getGroup();
        if (this.block.isShadow()) {
            // return;
            const data = this.block.toCopyData();
            // Blockly.Events.setGroup(true);
            this.copy = Blockly.clipboard.paste(data, this.block.workspace);

            // // bind the finishEditing_ function to the field, so user can rename the parameter
            // // after it is duplicated
            // const nameField = /**@type {VmtFieldFlyoutText}*/ (this.block.getField('PARAMETER_NAME'));
            // const parentBlock = this.block.getSurroundReusableBlock();
            // nameField.onFinishEditing_ = parentBlock.finishEditing_.bind(nameField);

            this.baseStrat = new Blockly.dragging.BlockDragStrategy(this.copy);
        }
        else {
            this.baseStrat = new Blockly.dragging.BlockDragStrategy(this.block);
        }
        // const data = this.block.toCopyData();
        // this.copy = Blockly.clipboard.paste(data, this.block.workspace);
        // this.baseStrat = new Blockly.dragging.BlockDragStrategy(this.copy);
        this.baseStrat.startDrag(e);
        // Blockly.Events.setGroup(prevGroupId);
    }

    drag(e) {
        this.baseStrat.drag(e);
    }

    endDrag(e) {
        this.baseStrat.endDrag(e);
    }

    revertDrag(e) {
        this.copy.dispose();
    }
}

/**
 * Reusable brick block definition.
 * @type {{
 *   init: Blockly.Blocks.vmt_parameter_reference.init
 * }}
 */
Blockly.Blocks['vmt_parameter_reference'] = {
    /**
    * Initializes the block.
    * @this {Blockly.Block}
    */
    init: function () {
        this.appendDummyInput('PARAM_INPUT')
            .appendField(new Blockly.FieldImage(paramOpenYellowImage, 10, 30), 'PARAM_IMAGE')
            .appendField(new VmtFieldFlyoutText('x', true), 'PARAMETER_NAME')
            .appendField(new Blockly.FieldImage(paramCloseYellowImage, 10, 30), 'PARAM_IMAGE');

        // setDragStrategy does not exist in headless mode
        if (typeof this.setDragStrategy == "function") {
            this.setDragStrategy(new DragToDupe(this)); // Attach drag strategy
        }

        this.setOutput(true, null);
        this.setTooltip('');
        this.setHelpUrl('');
        this.setColour(REUSABLE_BRICK_COLOR);
    },

    /**
     * Is this block enclosed (at any level) by a reusable block?
     *  If so, return the top level block, otherwise return null.
     * @this {Blockly.Block}
     * @return {Blockly.Block} The top level block that encloses this block.
     */
    getSurroundReusableBlock: function () {
        console.log('getSurroundReusableBlock');
        const reusableBlockTypes = new Set(['vmt_reusable_brick_init', 'vmt_reusable_brick_init_statement']);
        /** @type {{type: string, name: string, paramId: string, parentBlockId: string}} */
        const paramData = JSON.parse(this.data);
        const parentBlockId = paramData.parentBlockId;
        let block = this;
        // allow the parameter reference to be used as parameter value for
        // another reusable block which is inside the same reusable block
        const surroundBlock = block.getSurroundParent();
        if (surroundBlock && surroundBlock.type === 'vmt_parameter') {
            block = surroundBlock.getSurroundParent().getSurroundParent();
        }

        do {
            if (reusableBlockTypes.has(block.type)/* && block.id === parentBlockId*/) {
                if (block.id === parentBlockId) {
                    return block;
                }
                // return block;
                return null;
            }
            block = block.getSurroundParent();
        } while (block);
        return null;
        // return false;
    },

    // NOTE: the heavy lifting connection checks is done in VMTConnectionChecker.js
    /**
     * It checks for the parameter reference location and sets the warning message accordingly.
     * @param {Blockly.Events.Abstract} e Change event.
     * @this {Blockly.BlockSvg}
     */
    onchange: function (e) {

        // bind the finishEditing_ function to the field, so user can rename the parameter
        // on its creation/loading
        if ((e.type === Blockly.Events.BLOCK_CREATE && e.ids.includes(this.id)) || e.type === Blockly.Events.FINISHED_LOADING) {
            /** @type {{type: string, name: string, paramId: string, parentBlockId: string}} */
            const paramData = JSON.parse(this.data);
            const parentBlockId = paramData?.parentBlockId || '';
            if (parentBlockId === '') {
                return;
            }
            const parentBlock = this.workspace.getBlockById(parentBlockId);
            if (parentBlock?.type === 'vmt_reusable_brick_init_statement') {
                const nameField = /**@type {VmtFieldFlyoutText}*/ (this.getField('PARAMETER_NAME'));
                nameField.onFinishEditing_ = parentBlock.finishEditing_.bind(nameField); // bind the finishEditing_ function to the field
            }
        }

        // // cater undo/redo events
        // if (e.type === Blockly.Events.BLOCK_CHANGE && e.blockId === this.id) {
        //     console.log('onchange >vmt_parameter_reference<', e, this.getField('PARAMETER_NAME').getText(), this.id, e.blockId);
        //     // const paramData = JSON.parse(this.data);
        //     // const parentBlockId = paramData?.parentBlockId || '';
        //     // const parentBlock = this.workspace.getBlockById(parentBlockId);
        //     const nameField = /**@type {VmtFieldFlyoutText}*/ (this.getField('PARAMETER_NAME'));
        //     nameField.onFinishEditing_(e.newValue); // bind the finishEditing_ function to the field
        //     return;
        // }

        if (this.isShadow()) {
            return;
        }


        const warningMsg = 'Warning: This block may only be used inside its own reusable block';
        const ws = this.workspace;
        // Don't change state if:
        //   * It's at the start of a drag.
        //   * It's not a move event.
        if (
            !ws.isDragging ||
            ws.isDragging() ||
            (e.type !== Blockly.Events.BLOCK_MOVE && e.type !== Blockly.Events.BLOCK_CREATE)
        ) {
            return;
        }
        const enabled = !!this.getSurroundReusableBlock();
        this.setWarningText(enabled ? null : warningMsg);

        if (!this.isInFlyout) {
            try {
                // There is no need to record the enable/disable change on the undo/redo
                // list since the change will be automatically recreated when replayed.
                Blockly.Events.setRecordUndo(false);
                this.setDisabledReason(
                    !enabled,
                    warningMsg,
                );
            } finally {
                Blockly.Events.setRecordUndo(true);
            }
        }
    }
};
